export default {"src":"/_next/static/media/ra-fill-email.7cd33891.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};